/**
 * Pagination Utilities
 * 
 * This module contains utilities for handling pagination in the DataGrid component.
 */

/**
 * Calculate pagination row range
 */
export interface RowRangeParams {
  /** Total number of rows */
  totalRows: number;
  /** Current page (1-indexed) */
  currentPage: number;
  /** Number of rows per page */
  pageSize: number;
}

export interface RowRange {
  /** Start row index (0-indexed) */
  startRow: number;
  /** End row index (exclusive, 0-indexed) */
  endRow: number;
  /** Total number of pages */
  totalPages: number;
}

/**
 * Calculate the row range for pagination
 */
export function calculateRowRange({ totalRows, currentPage, pageSize }: RowRangeParams): RowRange {
  if (totalRows <= 0) {
    return { startRow: 0, endRow: 0, totalPages: 0 };
  }
  
  const totalPages = Math.max(1, Math.ceil(totalRows / pageSize));
  const validPage = Math.min(Math.max(1, currentPage), totalPages);
  
  const startRow = (validPage - 1) * pageSize;
  const endRow = Math.min(startRow + pageSize, totalRows);
  
  return { startRow, endRow, totalPages };
} 